import { createTheme } from "@mui/material/styles";

// Enhanced color palette with gradient definitions
const colors = {
	primary: {
		main: "#1a4789",
		light: "#a2c0ff",
		lighter: "#e0eaff",
		lightest: "#e8effd",
		dark: "#0d2e5e",
		darker: "#0a2448",
	},
	accent: {
		main: "#FAD461",
		light: "#fce09b",
		dark: "#e6c054",
	},
	neutral: {
		white: "#ffffff",
		light: "#f8f9fa",
		medium: "#e9ecef",
		dark: "#333333",
	},
};

// Gradient definitions for consistent use across components
const gradients = {
	primary: {
		// Main site background - top to bottom flow
		topDown: `linear-gradient(
      to bottom,
      ${colors.primary.lightest} 0%,
      ${colors.primary.lighter} 25%,
      ${colors.primary.light} 50%,
      ${colors.primary.lighter} 75%,
      ${colors.primary.lightest} 100%
    )`,
		// Enhanced version with more depth
		topDownDeep: `linear-gradient(
      to bottom,
      ${colors.primary.lightest} 0%,
      ${colors.primary.lighter} 15%,
      rgba(162, 192, 255, 0.8) 30%,
      rgba(26, 71, 137, 0.1) 50%,
      rgba(162, 192, 255, 0.6) 70%,
      ${colors.primary.lighter} 85%,
      ${colors.primary.lightest} 100%
    )`,
		// Diagonal flow for sections
		diagonal: `linear-gradient(
      135deg,
      ${colors.primary.lightest} 0%,
      rgba(162, 192, 255, 0.7) 25%,
      rgba(250, 212, 97, 0.1) 50%,
      rgba(162, 192, 255, 0.8) 75%,
      ${colors.primary.lighter} 100%
    )`,
		// Radial for hero sections
		radial: `radial-gradient(
      ellipse at top,
      ${colors.primary.lightest} 0%,
      rgba(162, 192, 255, 0.9) 30%,
      rgba(26, 71, 137, 0.1) 70%,
      ${colors.primary.lighter} 100%
    )`,
	},
	sections: {
		// For parallax backgrounds
		parallax: `linear-gradient(
      135deg,
      rgba(26, 71, 137, 0.3) 0%,
      rgba(161, 192, 255, 0.4) 25%,
      rgba(250, 212, 97, 0.2) 50%,
      rgba(26, 71, 137, 0.2) 75%,
      rgba(161, 192, 255, 0.3) 100%
    )`,
		// Smooth transitions between sections
		transition: (topColor, bottomColor, opacity = 1) => `
      linear-gradient(
        to bottom,
        ${topColor} 0%,
        rgba(255, 255, 255, ${opacity * 0.1}) 20%,
        rgba(162, 192, 255, ${opacity * 0.05}) 50%,
        rgba(255, 255, 255, ${opacity * 0.1}) 80%,
        ${bottomColor} 100%
      )
    `,
	},
	footer: {
		main: `linear-gradient(
      135deg,
      ${colors.primary.main} 0%,
      ${colors.primary.dark} 50%,
      ${colors.primary.darker} 100%
    )`,
	},
};

const theme = createTheme({
	palette: {
		primary: {
			main: colors.primary.main,
			light: colors.primary.light,
			dark: colors.primary.dark,
		},
		secondary: {
			main: colors.accent.main,
		},
	},
	// Add custom properties to theme
	colors,
	gradients,
	typography: {
		fontFamily: "'Heebo', serif, Arial, sans-serif",
		body1: {
			fontFamily: "'Heebo', sans-serif",
			fontSize: "22px",
		},
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 900,
			lg: 1200,
			xl: 2000,
		},
	},
	components: {
		// Name of the component

		MuiPaper: {
			styleOverrides: {
				// Name of the slot
				root: {
					// Some CSS
					// background: "radial-gradient(circle at 70% 50%, #ffffff 0%, #e0eaff 30%, #b8d0ff 60%, #a2c0ff 100%)",
					overflow: "hidden",
					border: "none", // Explicitly remove borders
					boxShadow: "none",
					marginBottom: 0,
					// pb: 0,
					// maxWidth: "md",
					// borderRadius: "0",
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				// Name of the slot
				root: {
					// Some CSS
					"& .MuiOutlinedInput-root": {
						"&.Mui-focused fieldset": {
							borderColor: "#a2c0ff",
						},
						"&:hover fieldset": {
							borderColor: "#a2c0ff",
						},
					},
					"& .MuiFormLabel-root.Mui-focused": {
						color: "#a2c0ff",
					},
				},
			},
		},
	},
});

export default theme;
export { colors, gradients };
